var _tspan, _tspan2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlfaRomeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 18,
    style: {
      fill: "#1C3D72",
      font: "10px sans-serif",
      textAnchor: "middle"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 20
  }, "Alfa")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 20,
    dy: "1.2em"
  }, "Romeo"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlfaRomeo);
export default __webpack_public_path__ + "static/media/alfa_romeo.449f487c62a860288e1a829ab52cd4bb.svg";
export { ForwardRef as ReactComponent };